import React from 'react'
import { connect } from 'react-redux'
import classes from './styles.module.scss'
// import { FormattedMessage } from 'react-intl'
import { handleAmount, intl, recordCountlyEvent } from 'utils'
import messages from './messages'
import { Form, Input, Button, Row, Col, Divider, Checkbox, Switch, Tooltip } from 'antd'
import {
  cardNumberRule,
  expireDateRule,
  securityCodeRule,
  isAmexCardNumber,
  nameRule,
  emailRule,
  agreementRule,
} from 'utils/validateRules'
import WhiteSpace from 'components/WhiteSpace'
import LoginDrawer from 'components/LoginDrawer'
import { init } from 'routes/PayPage/Main/modules'
import { queryProtocol } from 'store/siteConfig'
import _ from 'lodash'
import WingBlank from 'components/WingBlank'
import { NavigatorWithQS } from 'utils/navigateWithQS'
import { Flex } from 'antd-mobile'
import { Pci, PoweredBy, Privacy, Terms } from 'components/TermsAndPrivacy/TermsAndPrivacy'
import { FormattedMessage } from 'react-intl'
import VisaInstallments from '../VisaInstallments'
import {
  getCardBrandIconKey,
  getCardBrandIconsWithJaywanAfterVisa,
  getSupportedCardIconsFromPayMethods,
} from './cardBrandIcons'

const setCachedPaymentMethodForResult = (orderToken, data) => {
  if (!orderToken) return
  try {
    sessionStorage.setItem(`paypage-paymentMethod-${orderToken}`, JSON.stringify(data))
  } catch (e) {
    // ignore storage issues
  }
}

const FormPartWrapper = (props) => {
  return (
    <Form key='formPartWrapper' className={classes.componentsPaymentMethodsAddNewCard}>
      {props.children}
    </Form>
  )
}

const FormFooterWrapper = (props) => <div className={classes.formFooterContainer}>{props.children}</div>
class AddNewCard extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      LoginDrawerVisible: false,
      installmentPlans: null,
      showInstallments: false,
      pendingPaymentData: null,
      isAmex: false,
      supportedCardIcons: [],
    }

    console.log(props.siteConfig)
    if (props.siteConfig.loginType === 'customerId') {
      this.props.queryProtocol({ protocolScene: 'MCHT_USER_BIND_CARD' })
    }
    const { history, location } = props
    this.navigateWithQS = NavigatorWithQS.getInstance(history, location)
  }

  componentDidMount() {
    this.setState({
      supportedCardIcons: this.getSupportedCardIcons()
    })
  }

  getSupportedCardIcons = () => {
    return getSupportedCardIconsFromPayMethods(this.props.payMethods)
  }

  handleCardNoChange = (e) => {
    const value = e.target.value || ''
    const isAmex = isAmexCardNumber(value)

    if (isAmex !== this.state.isAmex) {
      this.setState({ isAmex }, () => {
        this.props.form.setFieldsValue({ cvv: undefined })
      })
    }
  }

  handleSubmit = (e) => {
    e.preventDefault()
    console.log('AddNewCard handleSubmit called')
    this.props.form.validateFields(
      ['cardNo', 'expireDate', 'cvv', 'holderName', 'payerEmail', 'isSaveCard'],
      (err, values) => {
        console.log('AddNewCard form validation result:', { err, values })
        if (!err) {
          const { pageName } = this.props
          pageName &&
            recordCountlyEvent({
              page_name: pageName,
              event_name: 'click',
              element_name: 'card_pay',
              biz_tags: {
                trade_voucher_no: sessionStorage.orderNo
              }
            })

          // If installments UI is already shown, payment is handled by VisaInstallments component
          if (this.state.showInstallments) {
            return
          }

          // Call installment plan API before submitting payment
          const cardNo = values.cardNo ? values.cardNo.replace(/ /g, '') : null
          console.log('AddNewCard - cardNo:', cardNo)

          if (cardNo && this.props.actions && this.props.actions.queryInstallPlan) {
            console.log('AddNewCard - Calling queryInstallPlan API with card details')
            const apiPromise = this.props.actions.queryInstallPlan({
              cardNo: values.cardNo,
              expireDate: values.expireDate,
              holderName: values.holderName,
              cvv: values.cvv,
            })
            console.log('AddNewCard - API promise:', apiPromise)
            apiPromise
              .then((res) => {
                console.log('AddNewCard - Installment Plan API Response (full):', res)
                console.log('AddNewCard - Installment Plan API Response (payload):', res.payload)
                const { installmentPlanList, supplierCode } = res.payload || {}
                // If supplierCode is VISA and we have installment plans, show installments UI
                if (supplierCode === 'VISA' && installmentPlanList && installmentPlanList.length > 0) {
                  // Cache card suffix from the entered PAN (last4) so result page can display "...Card(XXXX)"
                  const panDigits = cardNo ? String(cardNo).replace(/\D/g, '') : ''
                  const cardNoSuffix = panDigits ? panDigits.slice(-4) : undefined
                  setCachedPaymentMethodForResult(this.props.siteConfig.orderToken, {
                    cardBrand: supplierCode.toLowerCase(),
                    cardNoSuffix,
                    supplierCode,
                  })
                  console.log('AddNewCard - Showing installments UI')
                  this.setState({
                    installmentPlans: installmentPlanList,
                    showInstallments: true,
                    pendingPaymentData: values,
                  })
                } else {
                  // No installments available, proceed with normal payment flow (card-token-pay)
                  console.log('AddNewCard - No installments, proceeding with normal payment')
                  this.props.submit({
                    ...values,
                    isSaveCard: values.isSaveCard ? 'Y' : undefined, // 重置isSaveCard的值
                    method: 'PAY_WITH_NEW_CARD',
                    siteConfig: this.props.siteConfig,
                    tabName: this.props.tabName
                  })
                }
              })
              .catch((err) => {
                console.log('AddNewCard - Installment Plan API Error (full):', err)
                console.log('AddNewCard - Installment Plan API Error (message):', err?.message)
                // On error, proceed with normal payment flow
                this.props.submit({
                  ...values,
                  isSaveCard: values.isSaveCard ? 'Y' : undefined, // 重置isSaveCard的值
                  method: 'PAY_WITH_NEW_CARD',
                  siteConfig: this.props.siteConfig,
                  tabName: this.props.tabName
                })
              })
          } else {
            console.log('AddNewCard - Skipping API call, cardNo:', cardNo, 'actions available:', !!this.props.actions)
            // Proceed with payment if no cardNo or action not available
            this.props.submit({
              ...values,
              isSaveCard: values.isSaveCard ? 'Y' : undefined, // 重置isSaveCard的值
              method: 'PAY_WITH_NEW_CARD',
              siteConfig: this.props.siteConfig,
              tabName: this.props.tabName
            })
          }
        } else {
          console.log('AddNewCard - Form validation errors:', err)
        }
      }
    )
  }

  handleInstallmentPay = (data) => {
    const { pendingPaymentData } = this.state
    if (pendingPaymentData) {
      this.props.submit({
        ...pendingPaymentData,
        isSaveCard: pendingPaymentData.isSaveCard ? 'Y' : undefined,
        method: 'PAY_WITH_NEW_CARD',
        siteConfig: this.props.siteConfig,
        tabName: this.props.tabName,
        installmentPlanId: data.installmentPlanId,
        installmentPlan: data.installmentPlan,
      })
    }
  }

  render() {
    const { siteConfig, form, loading, optAddCardItems = [], pageName, saveCard } = this.props
    const { getFieldDecorator } = form
    const { showInstallments, installmentPlans, isAmex, supportedCardIcons } = this.state
    const hideCopyright = _.get(siteConfig, 'pageCustomize.hidePowerByPayBy') === true
    const cardBrandIcons = getCardBrandIconsWithJaywanAfterVisa(supportedCardIcons)
    // Show installments UI if available
    if (showInstallments && installmentPlans) {
      return (
        <div className={classes.componentsPaymentMethodsAddNewCard}>
          <VisaInstallments
            installmentPlans={installmentPlans}
            loading={loading}
            onPay={this.handleInstallmentPay}
            siteConfig={siteConfig}
          />
        </div>
      )
    }

    const formPartNode = (
      <>
        <WhiteSpace size='lg' />
        <Flex align='center' justify='center' className='text-center paragraph_regular text_secondary'>
          {intl().formatMessage(messages.Enter_the_card_information_or_login_your_mobile_number_to_show_your_saved_card_details)}
        </Flex>
        <WhiteSpace size='lg' />
        {optAddCardItems.indexOf('login') > -1 && !siteConfig.loginToken && (
          <div>
            <Button
              block
              className={`${classes.LoginButton} button_regular`}
              size='large'
              type='ghost'
              onClick={() => {
                pageName &&
                  recordCountlyEvent({
                    page_name: pageName,
                    event_name: 'click',
                    element_name: 'check',
                    biz_tags: {
                      trade_voucher_no: sessionStorage.orderNo
                    }
                  })
                if (siteConfig.isMobile) {
                  this.navigateWithQS.push('/pay-page/main/mobile-payment-container/login')
                  return
                }
                this.setState({ LoginDrawerVisible: true })
              }}
            >
              {intl().formatMessage(messages.HaveSavedCardCheck)}
            </Button>
            {!siteConfig.isMobile && (
              <>
                <LoginDrawer
                  title={intl().formatMessage(messages.UseMyHistory)}
                  btnText={intl().formatMessage(messages.BtnText)}
                  visible={this.state.LoginDrawerVisible}
                  pcProps={{
                    getContainer: '#rightSection',
                  }}
                  onChange={(LoginDrawerVisible) => {
                    pageName &&
                      recordCountlyEvent({
                        page_name: pageName,
                        event_name: 'click',
                        element_name: 'close_login_popup',
                      })
                    this.setState({ LoginDrawerVisible })
                  }}
                  type='LOGIN'
                />
                <WhiteSpace size='xl' />
                <Divider>
                  <span className='text_placeholder font-12'>
                    {intl().formatMessage(messages.OrOnetimePaywithCard)}
                  </span>
                </Divider>
              </>
            )}
            <WhiteSpace size='xl' />
          </div>
        )}

        <Form.Item>
          {getFieldDecorator(
            'cardNo',
            cardNumberRule()
          )(
            <Input
              size='large'
              pattern='\d*'
              inputMode='numeric'
              onChange={this.handleCardNoChange}
              suffix={
                <span style={{ display: 'inline-flex', alignItems: 'center', gap: '4px' }}>
                  {cardBrandIcons.map((item) => (
                    <img key={getCardBrandIconKey(item)} height={18} src={item.iconUrl} alt='' />
                  ))}
                </span>
              }
              placeholder={intl().formatMessage(messages.CardNoPlaceholder)}
            />
          )}
        </Form.Item>
        <Row gutter={8}>
          <Col span={12}>
            <Form.Item>
              {getFieldDecorator(
                'expireDate',
                expireDateRule()
              )(
                <Input
                  size='large'
                  pattern='\d*'
                  inputMode='numeric' // 安卓上强制使用数字键盘
                  placeholder={intl().formatMessage(
                    messages.ExpireDatePlaceholder
                  )}
                />
              )}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item>
              {getFieldDecorator(
                'cvv',
                securityCodeRule(isAmex)
              )(
                <Input
                  type='password'
                  size='large'
                  pattern='\d*'
                  inputMode='numeric'
                  maxLength={isAmex ? 4 : 3}
                  suffix={
                    <img height={22} src={require('./images/img2.png')} />
                  }
                  placeholder='CVV'
                />
              )}
            </Form.Item>
          </Col>
        </Row>
        <Form.Item>
          {getFieldDecorator(
            'holderName',
            nameRule()
          )(
            <Input
              size='large'
              placeholder={intl().formatMessage(
                messages.CardholderNamePlaceholder
              )}
            />
          )}
        </Form.Item>

        {optAddCardItems.indexOf('email') > -1 && (!siteConfig.loginToken || siteConfig.loginType !== 'memberPhone') && (
          <Form.Item>
            {getFieldDecorator(
              'payerEmail',
              emailRule()
            )(
              <Input
                size='large'
                suffix={
                  <Tooltip
                    arrowPointAtCenter
                    placement={siteConfig.dir === 'rtl' ? 'topLeft' : 'topRight'}
                    title={intl().formatMessage(messages.Incasethatyouwanttoreceiveyourpaymentreceipt)}
                    visible={this.state.payerEmailTooltipVisible}
                    onClick={() => this.setState({ payerEmailTooltipVisible: true })}
                    onMouseEnter={() => this.setState({ payerEmailTooltipVisible: true })}
                    onMouseLeave={() => this.setState({ payerEmailTooltipVisible: false })}
                  >
                    <span className='iconfont iconcomm-question-fill font-20 fill_icon_secondary' />
                  </Tooltip>
                }
                placeholder={intl().formatMessage(messages.EmailPlaceholder)}
              />
            )}
          </Form.Item>
        )}

        {optAddCardItems.indexOf('saveCard') > -1 && siteConfig.loginToken && (
          <>
            <Row style={{ marginTop: -6 }}>
              <Col span={12}>{intl().formatMessage(messages.Savefornexttimeuse)}</Col>
              <Col span={12}>
                <div className='text-right'>
                  {getFieldDecorator('isSaveCard', {
                    initialValue: true,
                    valuePropName: 'checked'
                  })(<Switch disabled={saveCard === 'Y'} />)}
                </div>
              </Col>
            </Row>
            {/* email登陆态的提示 */}
            {siteConfig.loginType === 'memberPhone' && siteConfig.memberPhone && (
              <>
                <WhiteSpace size='md' />
                <WingBlank className='fill_special text_secondary font-12'>
                  <WhiteSpace />
                  {form.getFieldValue('isSaveCard')
                    ? `${intl().formatMessage(messages.SavedwithEmail)} ${siteConfig.memberPhone}`
                    : intl().formatMessage(messages.PayBypaymentprovidesservicetothousandsmerchants)}
                  <WhiteSpace />
                </WingBlank>
              </>
            )}
            {/* customerId传参的提示 */}
            {siteConfig.loginType === 'customerId' && (
              <>
                <WhiteSpace size='md' />
                <WingBlank className='fill_special text_secondary font-12'>
                  <WhiteSpace />
                  {intl().formatMessage(messages.Savedwithyourorderaccountid)}
                  <WhiteSpace />
                </WingBlank>
              </>
            )}
            <WhiteSpace size='md' />
          </>
        )}
      </>
    )
    const footerPartNode = (
      <>
        {optAddCardItems.indexOf('agreements') > -1 &&
          siteConfig.loginToken &&
          siteConfig.loginType === 'customerId' &&
          siteConfig.agreementTips && (
          <Form.Item key='agreements' className={`${classes.checkbox} text-left`}>
            {form.getFieldDecorator(
              'agreements',
              agreementRule()
            )(
              <Checkbox>
                <span
                  className='font-12'
                  dangerouslySetInnerHTML={{
                    __html: siteConfig.agreementTips,
                  }}
                />
              </Checkbox>
            )}
          </Form.Item>
        )}

        <Form.Item>
          <Button
            loading={loading}
            block
            size='large'
            type='primary'
            onClick={this.handleSubmit}
          >
            {intl().formatMessage(messages.Pay)} {_.get(siteConfig, 'payInfo.payAmount') && handleAmount(siteConfig.payInfo.payAmount)}
          </Button>
        </Form.Item>

        {optAddCardItems.indexOf('PCI') > -1 && (
          <Row gutter={4}>
            <Col span={8} className='text-right'>
              <img height={14} src={require('./images/img3.png')} />
            </Col>
            <Col span={16}>
              <div className='font-12 text_placeholder' style={{ lineHeight: 1.2 }}>
                {intl().formatMessage(messages.PCI)}
              </div>
            </Col>
          </Row>
        )}
      </>
    )
    if (siteConfig.isMobile) {
      return (
        <>
          <Flex.Item>
            <FormPartWrapper key='mobileForm'>{formPartNode}</FormPartWrapper>
          </Flex.Item>
          <FormFooterWrapper>
            <Divider style={{ margin: '0 0 20px 0' }} />
            <WingBlank>
              <div className={classes.mobileLogoBlock}>
                {hideCopyright !== true && (
                  <div className={classes.mobilePoweredBy}>
                    <PoweredBy />
                  </div>
                )}
                <div className={classes.mobileSecurityLogos}>
                  <Pci />
                </div>
              </div>
              <WhiteSpace />
              <div className='caption_regular'>
                <FormattedMessage
                  values={{
                    terms: <Terms />,
                    privacy: <Privacy />
                  }}
                  {...messages.Bycontinuingyourpaymentyouagreetotheour}
                />
              </div>
              <WhiteSpace size='md' />
              {footerPartNode}
            </WingBlank>
          </FormFooterWrapper>
        </>
      )
    }
    return (
      <FormPartWrapper>
        {formPartNode}
        {footerPartNode}
      </FormPartWrapper>
    )
  }
}

const mapDispatchToProps = (dispatch) => {
  const { queryInstallPlan } = require('routes/PayPage/Main/modules')
  return {
    init,
    queryProtocol,
    actions: {
      queryInstallPlan: (data) => {
        console.log('AddNewCard mapDispatchToProps - queryInstallPlan called with:', data)
        return dispatch(queryInstallPlan(data))
      },
    },
  }
}

export default connect(
  (state) => ({
    siteConfig: state.siteConfig,
  }),
  mapDispatchToProps
)(Form.create()(AddNewCard))
